import { useEffect } from "react";
import { changeLanguage } from "i18next";

type UseDefaultLanguageProps = {
  defaultLocale: string;
  urlLocale: string;
};

const useDefaultLanguage = ({ defaultLocale, urlLocale }: UseDefaultLanguageProps) => {
  useEffect(() => {
    const locale = urlLocale || defaultLocale;
    if (locale) {
      changeLanguage(locale);
    }
  }, [defaultLocale, urlLocale]);
};

export default useDefaultLanguage;
